// extracted by mini-css-extract-plugin
export default {"flex":"Login_flex__eUw8N","container":"Login_container__FtxIa","inputs":"Login_inputs__9p6cC","logo":"Login_logo__4oQAQ"};